import { render, staticRenderFns } from "./AddAccessPoints.vue?vue&type=template&id=85afc420&"
import script from "./AddAccessPoints.vue?vue&type=script&lang=ts&"
export * from "./AddAccessPoints.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports